<ng-container *ngIf="showCard; else resumeWithoutCard">
  <common-mojo-expandable-card
    (toggle)="toggleCard($event)"
    [expandable]="expandable"
  >
    <ng-container [ngTemplateOutlet]="resumeWithoutCard"></ng-container>
  </common-mojo-expandable-card>
</ng-container>

<ng-template #resumeWithoutCard>

  <mojo-candidate-resume-card-header [showTitle]="showCard">
  </mojo-candidate-resume-card-header>

  <div
    *ngIf="displayedOverview?.type"
    class="item overview"
  >
    <div
      class="overview-type"
      [attr.data-cy]="'candidate-resume-card-' + (displayedOverview.type | lowercase) + '-overview-type'"
    >{{displayedOverview.type}}</div>
    <span
      class="overview-text"
      [attr.data-cy]="'candidate-resume-card-' + (displayedOverview.type | lowercase) + '-overview-text'"
    >{{displayedOverview.text}}</span>
  </div>

  <div
    class="experience-list"
    [ngClass]="{'font-size-talent-pool': !showCard}"
  >
    <div
      *ngFor="let experience of displayedExperiences; trackBy: trackElement"
      class="item"
    >

      <div class="job-title">{{ experience?.jobTitle }}</div>

      <div class="employer-name">{{ experience?.employerName }}</div>

      <div class="job-location comma-separate">
        <span>{{ experience?.jobLocation?.city }}</span>
        <span>{{ experience?.jobLocation?.state }}</span>
        <span>{{ experience?.jobLocation?.country }}</span>
      </div>

      <div class="dates">{{ experience?.period }}</div>

      <div class="responsibilities">
        Responsibilities:
        <ul class="responsibilities-list">
          <li
            [innerHtml]="summary"
            *ngFor="let summary of experience?.responsibilites; index as index"
            class="responsibility"
            [attr.data-cy]="'candidate-resume-card-job-experience-summary-' + index"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</ng-template>
